import { Action, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { Navigate, RouterNavigated } from '@ngxs/router-plugin';
import { NavigationActions } from '@shared/store/navigation/navigation.actions';
import { Location } from '@angular/common';
import { RouterStateSnapshot } from '@angular/router';

export interface NavigationStateModel {
  history: string[];
}

@State<NavigationStateModel>({
  name: 'navigation',
  defaults: {
    history: []
  }
})
@Injectable()
export class NavigationState {
  private location = inject(Location);

  @Action(RouterNavigated<RouterStateSnapshot>)
  public routerNavigated(ctx: StateContext<NavigationStateModel>, action: RouterNavigated) {
    const state = ctx.getState();
    ctx.patchState({ history: [ ...state.history, action.event.urlAfterRedirects ] });
  }

  @Action(NavigationActions.Back)
  public back(ctx: StateContext<NavigationStateModel>, action: NavigationActions.Back) {
    const state = ctx.getState();

    if (state.history.length > 1) {
      const history = state.history;
      ctx.patchState({ history: [ ...history.slice(0, history.length - 1) ] });
      this.location.back();
    } else {
      ctx.dispatch(new Navigate(action.path || [ '/' ], action.queryParams, {
        ...action.extras
      }));
    }
  }

}